const customFallback = {
  we_apologize: "Nous nous excusons, une erreur s'est produite",
  help_our_budly_team: 'Aidez notre équipe à corriger cette erreur',
  report_the_error: "Signaler l'erreur",
}

export default customFallback
